import React, { useEffect, useState } from 'react'
import Table from 'components/Table'
import { PastPurchaseContainer } from './PastPurchase.styled'
import PastPurchaseItem from './PastPurchaseItem'
import { useAppState, useAppDispatch } from 'store'
import { userActions } from 'store/slices/users/users.slice'
import Spinner from 'components/Spinner'
import { useParams } from 'react-router'
import { UserPastPurchase } from 'models/user.model'
import TransactionDetailsModal from '../TransactionDetailsModal'
import Modal from 'components/Modal'
import { orderBy } from 'lodash'

const PAST_PURCHASE_LIST_HEADER: string[] = [
  'Date',
  'Amount',
  'Description',
  'Payment Status',
]

const PastPurchase = () => {
  const { locationId, clientId } = useParams<{
    locationId: string
    clientId: string
  }>()
  const { userTransactions, loadingUserTransaction } = useAppState(
    state => state.user
  )
  const dispatch = useAppDispatch()
  const [tableLoading, setTableLoading] = useState<boolean>(false)
  const [currentTransaction, setCurrentTransaction] = useState<
    UserPastPurchase | undefined
  >(undefined)
  const [transactions, setTransactions] = useState<UserPastPurchase[]>([])
  const [showModal, setShowModal] = useState<boolean>(false)

  useEffect(() => {
    return () => {
      userActions.clearUserTransactions()
    }
  }, [])

  useEffect(() => {
    if (locationId && clientId) {
      getTransactions();
    }
  }, [locationId, clientId])

  useEffect(() => {
    if (loadingUserTransaction === 'loading') {
      setTableLoading(true)
    }
    if (loadingUserTransaction === 'succeeded') {
      setTableLoading(false)
    }
  }, [loadingUserTransaction])

  useEffect(() => {
    if (userTransactions && userTransactions.length) {
      const newTransactions = orderBy(
        [...userTransactions],
        o => new Date(o.created_at),
        'desc'
      )

      setTransactions(newTransactions)
    }
  }, [userTransactions])

  const getTransactions = async()=>{
    dispatch(
      userActions.getUserTransactionsByLocation({
        locationId,
        userId: parseInt(clientId),
      })
    )
  }

  return (
    <PastPurchaseContainer>
      {tableLoading ? (
        <Spinner loading={tableLoading} />
      ) : (
        <Table header={PAST_PURCHASE_LIST_HEADER} styles={{ width: '100%' }}>
          {transactions.length &&
            transactions.map(transaction => (
              <PastPurchaseItem
                onClick={transaction => {
                  setCurrentTransaction(transaction)
                  setShowModal(true)
                }}
                transaction={transaction}
                key={transaction.id}
              />
            ))}
        </Table>
      )}
      {showModal && currentTransaction && (
        <Modal
          title={`Transaction #${currentTransaction.id} - ${currentTransaction.invoice_type}`}
          onClose={() => {
            setShowModal(false), setCurrentTransaction(undefined)
          }}>
          <TransactionDetailsModal
            transaction={currentTransaction}
            locationId={locationId}
            clientId={Number(clientId)}
            onClose={() => {
              setShowModal(false), setCurrentTransaction(undefined),
              getTransactions()
            }}
          />
        </Modal>
      )}
    </PastPurchaseContainer>
  )
}

export default PastPurchase
